import { Box } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { fetchOrganizationName } from 'src/api/queries';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { ISubmissionContextConfig } from '@publishing-engine/domain/models';
import SubmittingAuthorOnlyICMJEForm from './components/ICMJEForm/SubmittingAuthorOnlyICMJEForm';
import { SubmittingAuthorOnlyICMJEFormSubmitted } from './components/ICMJEForm/SubmittingAuthorOnlyICMJEFormSubmitted';
import SubmittingAuthoICMJEFormForAll from './components/ICMJEForm/SubmittingAuthorICMJEFormForAll';

interface Props {
  config: ISubmissionContextConfig;
}

export const ICMJETab: React.FC<Props> = ({ config }) => {
  const { fieldsResponse, icmjeForm } = useSubmissionData();

  const organizationNameQueryKey = [
    'organization-name',
    fieldsResponse.organizationId
  ];
  const { data: organizationNameData } = useQuery({
    queryKey: organizationNameQueryKey,
    queryFn: () =>
      fetchOrganizationName(fieldsResponse?.organizationId, 'author')
  });

  const isSubmittingAuthorOnlyICMJESubmitted =
    icmjeForm?.length && !icmjeForm[0]?.isRequested;

  const authorICMJEModel = config.authorICMJEModel ?? null;

  return (
    <Box>
      {authorICMJEModel === 'SubmittingAuthorOnly' ? (
        isSubmittingAuthorOnlyICMJESubmitted ? (
          <SubmittingAuthorOnlyICMJEFormSubmitted
            organizationName={organizationNameData?.name}
            submittingAuthorOnlyICMJEForm={icmjeForm[0]}
          />
        ) : (
          <SubmittingAuthorOnlyICMJEForm config={config} />
        )
      ) : null}
      {authorICMJEModel === 'SubmittingAuthorForAll' ? (
        isSubmittingAuthorOnlyICMJESubmitted ? (
          <SubmittingAuthorOnlyICMJEFormSubmitted
            organizationName={organizationNameData?.name}
            submittingAuthorOnlyICMJEForm={icmjeForm[0]}
          />
        ) : (
          <SubmittingAuthoICMJEFormForAll config={config} />
        )
      ) : null}
    </Box>
  );
};
